import * as t from 'ts-codec';
export const AppEnv = t.object({
    AUTH_SERVER: t.string,
    API_SERVER: t.string
});
